import { render } from "./BiomecanisteSection.vue?vue&type=template&id=a27df330&scoped=true"
import script from "./BiomecanisteSection.vue?vue&type=script&lang=js"
export * from "./BiomecanisteSection.vue?vue&type=script&lang=js"

import "./BiomecanisteSection.vue?vue&type=style&index=0&id=a27df330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27df330"]])

export default __exports__